/**
 * Bounding box of a set of laid-out points.
 *
 * Its own module because three things need it and none of them owns it: the
 * layout uses it to place the parked band below the graph, the canvas uses it
 * to fit the graph to the viewport, and the tests use it to assert extent.
 */

export type Bounds = { minX: number; minY: number; maxX: number; maxY: number }

/**
 * Extent of the given points.
 *
 * An empty input returns a unit box rather than Infinities, so callers dividing
 * by the width to compute a scale get a finite number instead of NaN — which
 * would render as a blank canvas with no error anywhere.
 */
export function layoutBounds(nodes: readonly { x: number; y: number }[]): Bounds {
  if (nodes.length === 0) return { minX: 0, minY: 0, maxX: 1, maxY: 1 }
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity
  for (const n of nodes) {
    if (n.x < minX) minX = n.x
    if (n.y < minY) minY = n.y
    if (n.x > maxX) maxX = n.x
    if (n.y > maxY) maxY = n.y
  }
  return { minX, minY, maxX, maxY }
}
